import request from '../../../../../../helpers/request';
import {
  baseErrMsg,
  isQueryEnabled,
  returnTypesValueKeys,
  urlKeys,
  urlToTypeIdsKey,
  urlList,
} from './config';

const createKey = (url) => [url];

const fetch = ({ url }) =>
  request.get(url, {}, undefined, 'Error', undefined, undefined, {}, true);

export const createQueriesOptions = ({ importType, valueType }) =>
  Object.values(urlKeys).map((url) => {
    const data = {
      queryKey: createKey(url),
      queryFn: () => fetch({ url }),
      staleTime: Infinity,
      enabled: isQueryEnabled[url](importType),
    };

    if (valueType === returnTypesValueKeys.data) {
      data.select = (data) =>
        data.filter(({ id }) => id !== 0).map(({ id }) => id);
    }
    return data;
  });

export const createLoadingWithError = (queries) => {
  let isLoading = false;
  let error;
  const refetchs = [];

  queries.forEach((query) => {
    const { data, isFetching, refetch } = query;

    if (!isLoading && isFetching) {
      isLoading = true;
    }

    if (data === 'Error') {
      refetchs.push(refetch);
    }
  });

  if (refetchs.length) {
    error = {
      message: baseErrMsg,
      refetch: () => Promise.all(refetchs.map((refetch) => refetch())),
    };
  }

  return { isLoading, error };
};

export const createQueriesData = (queries) =>
  queries.reduce((acc, query, index) => {
    const data = query.data;

    if (data && data !== 'Error') {
      const key = urlToTypeIdsKey[urlList[index]];
      acc[key] = data;
    }

    return acc;
  }, {});
